import Base64 from 'js-base64'

global.Base64 = Base64.encode?Base64:Base64.Base64

global.Mode = process.env.NODE_ENV === 'production' ? 'prod' : 'dev'
global.Url = {
  'dev': {
    serviceCategory:'b96c666cbced4ea4973d621eef8bfff7',
    serviceRtasrId: '2bb3e66a714e4be7b81b1ee31d2e5cb1',
    serviceGjpcId: 'efac53573d2541fe90f2ad5e595c05d3',
    serviceFysbId: 'a0e01d0117ff48f594c1a9069d777f6d',
    serviceZxyyhc: '1dc02c2cd43a48f49a54b3f283725893',
    countCategory: '982ffd3fe55d45659902f1eabb149dad',
    countTid: 'd212e4016410403a9ee4f16dd43f2712',
    quoteCategory: '07c69cc24f374638b83fa629ebc4b0d0',
    quoteTid: '02770f36bb3148dab0862b1c8b99fcf7',
    cpfwsqid: '563864202c2f44d6b1b4ab29f4841f7a',
    dhjqrnlzjjid: '6255f42fc2e04155a0abb3885d05c1f4',
    baseUrl: 'https://shandong.xfyun.cn',
    ssoUrl: 'https://ssodev.xfyun.cn',
    memberUrl: 'https://passport-shandong.xfyun.cn',
    aiuiUrl: '//aiui.iflyos.cn',
    zfUrl: 'http://zf.test-xfyun.cn'
  },
  'prod': {
    serviceCategory:'b96c666cbced4ea4973d621eef8bfff7',
    serviceRtasrId: '2bb3e66a714e4be7b81b1ee31d2e5cb1',
    serviceGjpcId: 'efac53573d2541fe90f2ad5e595c05d3',
    serviceFysbId: 'a0e01d0117ff48f594c1a9069d777f6d',
    serviceZxyyhc: '1dc02c2cd43a48f49a54b3f283725893',
    countCategory: '982ffd3fe55d45659902f1eabb149dad',
    countTid: 'd212e4016410403a9ee4f16dd43f2712',
    quoteCategory: '07c69cc24f374638b83fa629ebc4b0d0',
    quoteTid: '02770f36bb3148dab0862b1c8b99fcf7',
    cpfwsqid: 'b96c666cbced4ea4973d621eef8bfff7',
    dhjqrnlzjjid: '89af4d9885894be387a578f410664472',
    baseUrl: '//shandong.xfyun.cn',
    ssoUrl: 'https://sso.xfyun.cn',
    memberUrl: '//passport-shandong.xfyun.cn',
    aiuiUrl: '//aiui.iflyos.cn',
    zfUrl: 'http://zf.xfyun.cn'
  }
}



// WEBPACK FOOTER //
// ./app/config.js